<template>
  <v-form
    ref="carPlate"
    v-model="isValid"
    class="d-flex flex-column align-center justify-center"
  >
    <div class="question-text mb-2">
      {{ question.text }}
    </div>
    <div>
      <div v-if="!isMobile && showUpperSpace" style="height: 22px;"></div>
      <v-text-field
        v-model="answer"
        :rules="question.rules || []"
        :placeholder="question.placeholder || ''"
        :prepend-inner-icon="question.innerIcon || ''"
        :hide-details="!question.rules || question.rules.length === 0"
        :class="{'uppercase': isUpperCase}"
        dense
        filled
        rounded
        solo
        flat
        class="free-text-input"
        @keydown="validateInput"
        @input="updateAnswer"
      />
    </div>
  </v-form>
</template>

<script>
export default {
  name: 'TextQuestion',
  props: {
    question: {
      type: Object,
      required: true
    },
    currentAnswer: {
      type: Object,
      default: null
    },
    isUpperCase: Boolean,
    showUpperSpace: Boolean
  },
  data() {
    return {
      answer: '',
      isValid: true
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 961;
    }
  },
  methods: {
    validateInput(event) {
      if (this.question.onlyNumbers) {
        const specialKeys = [];
        specialKeys.push(8); //Backspace
        const keyCode = event.which ? event.which : event.keyCode;
        if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 96 && keyCode <= 105) && specialKeys.indexOf(keyCode) === -1) {
          event.preventDefault();
        }
      }
      return true;
    },
    updateAnswer() {
      setTimeout(() => {
        this.$emit('updateAnswer', {
          id: 1,
          text: this.answer,
          value: this.answer,
          questionId: this.question.id,
          questionText: this.question.text,
          isValid: this.isValid,
          multipleParentId: this.question.multipleParentId
        });
      }, 250);
    }
  }
};
</script>

<style scoped>
.question-text {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}
.free-text-input {
  border-radius: 4px;
  width: 355px;
}
.free-text-input.uppercase ::v-deep input {
  text-transform: uppercase;
  border: none;
}
.free-text-input ::v-deep input {
  border: none;
}
@media screen and (max-width: 600px) {
  .free-text-input, .free-text-input.uppercase {
    width: 100%;
    min-width: 260px;
  }
}
</style>
